/**
 * Generated from SplashScreenLayout.fla
 */
export function SplashScreenLayout(this: ISplashScreenLayout) {
	const cloud = this.cloud;
	if (!cloud[0] && cloud.elementFactory) {
		cloud[0] = cloud.elementFactory(0,undefined);
	}
	if (cloud[0]) {
		SplashScreenLayout_cloud1.call(cloud[0] as ISplashScreenLayout_cloud1);
		cloud[0].x = 98.25;
		cloud[0].y = 141.85;
		cloud[0].width = 262.50;
		cloud[0].height = 126.25;
		if (cloud[0].onLayout) cloud[0].onLayout();
	}
	if (!cloud[1] && cloud.elementFactory) {
		cloud[1] = cloud.elementFactory(1,undefined);
	}
	if (cloud[1]) {
		SplashScreenLayout_cloud2.call(cloud[1] as ISplashScreenLayout_cloud2);
		cloud[1].x = 976.7;
		cloud[1].y = 512.1;
		cloud[1].width = 279.45;
		cloud[1].height = 118.20;
		if (cloud[1].onLayout) cloud[1].onLayout();
	}
	if (!cloud[2] && cloud.elementFactory) {
		cloud[2] = cloud.elementFactory(2,undefined);
	}
	if (cloud[2]) {
		SplashScreenLayout_cloud3.call(cloud[2] as ISplashScreenLayout_cloud3);
		cloud[2].x = 211.35;
		cloud[2].y = 436.9;
		cloud[2].width = 168.70;
		cloud[2].height = 71.85;
		if (cloud[2].onLayout) cloud[2].onLayout();
	}
	if (!cloud[3] && cloud.elementFactory) {
		cloud[3] = cloud.elementFactory(3,undefined);
	}
	if (cloud[3]) {
		SplashScreenLayout_cloud4.call(cloud[3] as ISplashScreenLayout_cloud4);
		cloud[3].x = 765;
		cloud[3].y = 259.85;
		cloud[3].width = 190.00;
		cloud[3].height = 91.70;
		if (cloud[3].onLayout) cloud[3].onLayout();
	}
	if (!cloud[4] && cloud.elementFactory) {
		cloud[4] = cloud.elementFactory(4,undefined);
	}
	if (cloud[4]) {
		SplashScreenLayout_cloud5.call(cloud[4] as ISplashScreenLayout_cloud5);
		cloud[4].x = 118.6;
		cloud[4].y = 672;
		cloud[4].width = 261.25;
		cloud[4].height = 126.00;
		if (cloud[4].onLayout) cloud[4].onLayout();
	}
	const earth = this.earth;
	SplashScreenLayout_earth.call(this.earth);
	earth.x = 512;
	earth.y = 311;
	earth.width = 358.00;
	earth.height = 358.00;
	if (earth.onLayout) earth.onLayout();
	const bee = this.bee;
	SplashScreenLayout_bee.call(this.bee);
	bee.x = 357.9;
	bee.y = 410.5;
	bee.width = 65.80;
	bee.height = 67.00;
	if (bee.onLayout) bee.onLayout();
	const ladybug = this.ladybug;
	SplashScreenLayout_ladybug.call(this.ladybug);
	ladybug.x = 596.5;
	ladybug.y = 138.5;
	ladybug.width = 63.00;
	ladybug.height = 55.00;
	if (ladybug.onLayout) ladybug.onLayout();
	const loaderEmpty = this.loaderEmpty;
	SplashScreenLayout_loaderEmpty.call(this.loaderEmpty);
	loaderEmpty.x = 512;
	loaderEmpty.y = 567.6;
	loaderEmpty.width = 285.43;
	loaderEmpty.height = 58.81;
	if (loaderEmpty.onLayout) loaderEmpty.onLayout();
	const loaderFull = this.loaderFull;
	SplashScreenLayout_loaderFull.call(this.loaderFull);
	loaderFull.x = 511.75;
	loaderFull.y = 563.8;
	loaderFull.width = 272.49;
	loaderFull.height = 39.75;
	if (loaderFull.onLayout) loaderFull.onLayout();
	return this;
}
function SplashScreenLayout_cloud1(this: ISplashScreenLayout_cloud1) {
	if (this.setLayoutTexture) this.setLayoutTexture("cloud1.png", 0.499, 0.499);
	return this;
}
function SplashScreenLayout_cloud4(this: ISplashScreenLayout_cloud4) {
	if (this.setLayoutTexture) this.setLayoutTexture("cloud4.png", 0.500, 0.500);
	return this;
}
function SplashScreenLayout_cloud2(this: ISplashScreenLayout_cloud2) {
	if (this.setLayoutTexture) this.setLayoutTexture("cloud2.png", 0.500, 0.500);
	return this;
}
function SplashScreenLayout_cloud3(this: ISplashScreenLayout_cloud3) {
	if (this.setLayoutTexture) this.setLayoutTexture("cloud3.png", 0.500, 0.500);
	return this;
}
function SplashScreenLayout_cloud5(this: ISplashScreenLayout_cloud5) {
	if (this.setLayoutTexture) this.setLayoutTexture("cloud5.png", 0.500, 0.500);
	return this;
}
function SplashScreenLayout_earth(this: ISplashScreenLayout_earth) {
	if (this.setLayoutTexture) this.setLayoutTexture("earth.png", 0.500, 0.500);
	return this;
}
function SplashScreenLayout_bee(this: ISplashScreenLayout_bee) {
	if (this.setLayoutTexture) this.setLayoutTexture("bee.png", 0.500, 0.500);
	return this;
}
function SplashScreenLayout_ladybug(this: ISplashScreenLayout_ladybug) {
	if (this.setLayoutTexture) this.setLayoutTexture("ladybug.png", 0.500, 0.500);
	return this;
}
function SplashScreenLayout_loaderEmpty(this: ISplashScreenLayout_loaderEmpty) {
	if (this.setLayoutTexture) this.setLayoutTexture("loaderempty.png", 0.500, 0.500);
	return this;
}
function SplashScreenLayout_loaderFull(this: ISplashScreenLayout_loaderFull) {
	if (this.setLayoutTexture) this.setLayoutTexture("loaderfull.png", 0.500, -0.501);
	return this;
}
interface ISplashScreenLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ISplashScreenLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ISplashScreenLayoutSprite extends ISplashScreenLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ISplashScreenLayoutText extends ISplashScreenLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ISplashScreenLayoutPolygon extends Array<number> {
}
interface ISplashScreenLayout {
	readonly cloud: ISplashScreenLayoutArray<ISplashScreenLayout_cloud1|ISplashScreenLayout_cloud2|ISplashScreenLayout_cloud3|ISplashScreenLayout_cloud4|ISplashScreenLayout_cloud5>;
	readonly earth: ISplashScreenLayout_earth;
	readonly bee: ISplashScreenLayout_bee;
	readonly ladybug: ISplashScreenLayout_ladybug;
	readonly loaderEmpty: ISplashScreenLayout_loaderEmpty;
	readonly loaderFull: ISplashScreenLayout_loaderFull;
}
interface ISplashScreenLayout_cloud1 extends ISplashScreenLayoutSprite {
}
interface ISplashScreenLayout_cloud4 extends ISplashScreenLayoutSprite {
}
interface ISplashScreenLayout_cloud2 extends ISplashScreenLayoutSprite {
}
interface ISplashScreenLayout_cloud3 extends ISplashScreenLayoutSprite {
}
interface ISplashScreenLayout_cloud5 extends ISplashScreenLayoutSprite {
}
interface ISplashScreenLayout_earth extends ISplashScreenLayoutSprite {
}
interface ISplashScreenLayout_bee extends ISplashScreenLayoutSprite {
}
interface ISplashScreenLayout_ladybug extends ISplashScreenLayoutSprite {
}
interface ISplashScreenLayout_loaderEmpty extends ISplashScreenLayoutSprite {
}
interface ISplashScreenLayout_loaderFull extends ISplashScreenLayoutSprite {
}
